import { createFileRoute, Outlet } from "@tanstack/react-router";

import { CartProvider } from "@/components/dashboard/cart-context";

export const Route = createFileRoute("/dashboard-preview")({
  component: () => (
    <CartProvider>
      <Outlet />
    </CartProvider>
  ),
});
